import {userService} from "@/helpers/authservice/user.service";

export function authHeader() {
    let user = JSON.parse(userService.getClaims());
    if (user && user.token) {
        return { 'Authorization': 'Bearer ' + user.token };
    } else {
        return {};
    }
}